import {createAction} from '@reduxjs/toolkit';

export default createAction('SET_AREA_COVERAGE');
